<div style="text-align:center; margin-top:50px;">
  <h2>Google Login (FedCM ready)</h2>

  <!-- Google hivatalos gomb -->
  <div #googleBtnContainer></div>

  <button style="margin-top:20px;" (click)="showOneTap()">One Tap megjelenítése</button>

  <div *ngIf="token" style="margin-top:30px;">
    <h3>ID Token:</h3>
    <textarea cols="70" rows="4">{{ token }}</textarea>
  </div>
</div>
